import { defineComponent as _defineComponent } from 'vue'
import OtpComponent from "@/components/buyTokens/OtpComponent.vue";
import {ref} from "vue";
import {useUserServiceStore} from "@/store/userService.store";
import {useToast} from "vue-toastification";
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivateView',
  setup(__props, { expose: __expose }) {
  __expose();


const activationCode = ref<string>('');
const onActivateClick = () => {

  useUserServiceStore().activateEmailAccount(activationCode.value, onSuccess, onError, true);
};
const toast = useToast();
const router = useRouter();
const onSuccess = () => {
  toast.success('Account activated');
  router.push({name: 'publicSaleInfo'});
};
const onError = () => {
  toast.error('An error occurred');
};

const __returned__ = { activationCode, onActivateClick, toast, router, onSuccess, onError, OtpComponent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})